import Utils from '@/common/utils/utils';
import { IconButton, Tooltip, withStyles } from '@material-ui/core';
import { I18n } from 'aws-amplify';
import React, { useCallback } from 'react';
import { useState } from 'react';
import Constant from '../../../common/constant/Constant';

export default function CopyShortLink({ detailTicket }) {
    const { shortKey, type, generateLinkCorporationDomain } = detailTicket.dataShareLink;
    const [isShowFlagMessage, setIsShowFlagMessage] = useState(false);
    const FlagMessageCopyLink = withStyles({
        tooltip: {
            color: '#1DA578',
            backgroundColor: '#D7F4E2',
            padding: '8px 16px',
            fontSize: '14px',
            boxShadow: '6px 5px 5px -4px rgba(0,0,0,0.3)'
        },
        arrow: {
            color: '#D7F4E2'
        }
    })(Tooltip);

    const onClickCopyShareLink = useCallback(() => {
        const linkUrl = `${window.location.origin}/${Utils.getUrlShortShareLinkTicket({
            type,
            shortKey,
            subDomain: generateLinkCorporationDomain
        })}`;
        navigator.clipboard.writeText(linkUrl);
        setIsShowFlagMessage(true);

        setTimeout(() => {
            setIsShowFlagMessage(false);
        }, 3000);
    }, [detailTicket]);

    const isShowButtonCopyLink = () => {
        let isDraftTicket = detailTicket.public === Constant.TICKET_PUBLIC.DRAFT;
        if (isDraftTicket) return false;
        return true;
    };

    if (!isShowButtonCopyLink()) return null;

    return (
        <Tooltip
            title={I18n.get('LABEL-CHATPOST-SHARELINK-TOOLTIP')}
            arrow={true}
            placement="bottom"
        >
            <IconButton
                className="itemNav"
                onClick={onClickCopyShareLink}
                data-cy="detail-ticket-icon-chat"
                disabled={false}
            >
                <FlagMessageCopyLink
                    title={I18n.get('KNOWDEMSG002')}
                    placement="top-start"
                    arrow={true}
                    open={isShowFlagMessage}
                >
                    <img src="/assets/image/icon-link-share.svg" alt="" />
                </FlagMessageCopyLink>
            </IconButton>
        </Tooltip>
    );
}
